import $        from 'jquery';
import React    from 'react';
import ReactDOM from 'react-dom';
import Utils    from 'medscape/utils';

let CachedContent = {};
export default class Formulary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      content: CachedContent[props.path] ? CachedContent[props.path] : ''
    }
  }
  componentDidMount() {
    let $this = $(ReactDOM.findDOMNode(this));
    if(this.state.content.length==0){
        this.getContent();
    }
  }
  getContent() {
    if(CachedContent[this.props.path]) {
      this.setState({
          content: CachedContent[this.props.path]
      })
    } else {
      let formularyUrl = Utils.getCompiledHtml(this.props.path);
      if(window.medscape.config.env=="localhost") {
        formularyUrl = `/build/localhost/app${formularyUrl}/index.jsp`;
      }
      $.ajax({
        type: 'get',
        url: formularyUrl,
        cached: false,
        xhrFields: {
          withCredentials: true
        }
      }).then((response) => {
        CachedContent[this.props.path]=response;
        this.setState({
          content: CachedContent[this.props.path]
        })
      }, (error)=>{
          console.error("Formulary Error:",error)
      });
    }
  }
  render() {
    if(this.state.content.length==0) {
      return false;
    }
    let content = Utils.getDangerousHtml(this.state.content);
    return(
      <div className="formulary-content" dangerouslySetInnerHTML={content}></div>
    )
  }
}

Formulary.propTypes={
  path: React.PropTypes.string,
}
Formulary.defaultProps={
  path: null
}



// WEBPACK FOOTER //
// ./medscape_modules/formulary/app.jsx